import React, {useContext, useEffect, useRef} from "react";
import ModalUpdElementoKpiView from "./ModalUpdElementoKpiView";
import {TranslateContext} from "../../../../context/TranslateContext";
import * as Yup from "yup";
import {
    TIPO_ELEMENTO_FORMULA,
    TIPO_ELEMENTO_LABEL, TIPO_ELEMENTO_LISTA, TIPO_ELEMENTO_NOTA,
    TIPO_ELEMENTO_SOTTOLIVELLO,
    TIPO_ELEMENTO_VALORE
} from "../../../../utility/common";
import {aggiornaElementoKpiApi} from "../../services/KpiServices";

export default function ModalUpdElementoKpiController({
                                                          elemento,
                                                          show,
                                                          handleClose,
                                                          handleOk,
                                                          handleKo,
                                                          aggiungiRiga,
                                                      }) {

    const {translate} = useContext(TranslateContext);

    const formikRefTemplate = useRef();

    const initialValuesTemplate = {
        tipo: '',
        label: '',
        tags: '',
        formula: '',
        rowspan: '',
        colspan: '',
        placeholder: '',
        valori_lista: '',
        titolo_dettaglio: '',
        testo_dettaglio: '',
    };

    const SignupSchema = Yup.object().shape({
        tipo: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        rowspan: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        colspan: Yup.string()
            .required(translate('Questo campo è obbligatorio')),
        label: Yup.string()
            .max(200, translate('Valore troppo lungo'))
            .required(translate('Questo campo è obbligatorio'))
    });

    async function onSubmitFormTemplate(values) {
        const response = await aggiornaElementoKpiApi(elemento.id_kpi_elemento, values);
        if (response.data.result === 0) {
            handleOk();
        } else {
            handleKo();
        }
    }

    useEffect(() => {
        if (elemento && formikRefTemplate.current) {
            formikRefTemplate.current.setFieldValue('tipo', elemento.tipo);
            formikRefTemplate.current.setFieldValue('rowspan', elemento.rowspan);
            formikRefTemplate.current.setFieldValue('colspan', elemento.colspan);
            formikRefTemplate.current.setFieldValue('label', elemento.label);
            formikRefTemplate.current.setFieldValue('formula', elemento.formula);
            formikRefTemplate.current.setFieldValue('placeholder', elemento.placeholder);
            formikRefTemplate.current.setFieldValue('valori_lista', elemento.valori_lista);
            formikRefTemplate.current.setFieldValue('titolo_dettaglio', elemento.titolo_dettaglio);
            formikRefTemplate.current.setFieldValue('testo_dettaglio', elemento.testo_dettaglio);
        }
    }, [elemento, formikRefTemplate.current]);

    const tipiElemento = [
        {
            label: translate("Label"),
            value: TIPO_ELEMENTO_LABEL.toString(),
        },
        {
            label: translate("Label azzurra"),
            value: TIPO_ELEMENTO_SOTTOLIVELLO.toString(),
        },
        {
            label: translate("Formula"),
            value: TIPO_ELEMENTO_FORMULA.toString(),
        },
        {
            label: translate("Valore"),
            value: TIPO_ELEMENTO_VALORE.toString(),
        },
        {
            label: translate("Lista"),
            value: TIPO_ELEMENTO_LISTA.toString(),
        },
        {
            label: translate("Nota"),
            value: TIPO_ELEMENTO_NOTA.toString(),
        },
    ];

    return (
        <ModalUpdElementoKpiView
            elemento={elemento}
            show={show}
            handleClose={handleClose}
            translate={translate}
            initialValuesTemplate={initialValuesTemplate}
            formikRefTemplate={formikRefTemplate}
            SignupSchemaTemplate={SignupSchema}
            onSubmitFormTemplate={onSubmitFormTemplate}
            tipiElemento={tipiElemento}
            aggiungiRiga={aggiungiRiga}
            salvaElemento={() => {
                if (formikRefTemplate) {
                    formikRefTemplate.current.handleSubmit();
                }
            }}
        />
    )
}